<script>
import { Task } from '@/api'
import ListMixin from '@/crudBases/list/ListMixin'
import FiltersMixin from '@/views/Tasks/FiltersMixin'

export default {
  mixins: [ListMixin, FiltersMixin],
  data() {
    return {
      editRouteName: 'Task Detail',
      verboseName: 'Zadanie',
      verboseNamePlural: 'Zadania',
      listFields: [
        { prop: 'id', label: 'id' },
        {
          prop: 'first_step',
          label: 'typ zadania',
          formatter: this.getFirstStepLabel
        },
        {
          prop: 'status',
          label: 'status zadania',
          formatter: this.getStatusLabel
        },
        {
          prop: 'current_step_label',
          label: 'Aktualny krok'
        },
        {
          prop: 'created',
          label: 'Data utworzenia',
          formatter: this.formatDate('created')
        },
        {
          prop: 'run_at',
          label: 'Uruchom po',
          formatter: this.formatRunAtDate('run_at')
        }
      ]
    }
  },
  computed: {
    service() {
      return Task
    }
  },
  methods: {
    actions(scope) {
      return [
        {
          component: 'router-link',
          attrs: {
            to: this.getEditRoute(scope.row)
          },
          children: [
            this.getButtonComponent({ icon: 'fa fa-edit', title: 'Szczegóły' })
          ]
        },
        ...this.additionalActions(scope)
      ]
    }
  }
}
</script>
